function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Vega-Lite's singleton logger utility.
 */
var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _LocalLogger_level;
import { Debug, Error as ErrorLevel, Info, logger, Warn } from 'vega-util';
import * as _message from './message';
export { _message as message };
/**
 * Main (default) Vega Logger instance for Vega-Lite.
 */
var main = logger(Warn);
var current = main;
/**
 * Logger tool for checking if the code throws correct warning.
 */
export var LocalLogger = /*#__PURE__*/function () {
  function LocalLogger() {
    _classCallCheck(this, LocalLogger);
    this.warns = [];
    this.infos = [];
    this.debugs = [];
    _LocalLogger_level.set(this, Warn);
  }
  return _createClass(LocalLogger, [{
    key: "level",
    value: function level(_) {
      if (_) {
        __classPrivateFieldSet(this, _LocalLogger_level, _, "f");
        return this;
      }
      return __classPrivateFieldGet(this, _LocalLogger_level, "f");
    }
  }, {
    key: "warn",
    value: function warn() {
      var _this$warns;
      if (__classPrivateFieldGet(this, _LocalLogger_level, "f") >= Warn) (_this$warns = this.warns).push.apply(_this$warns, arguments);
      return this;
    }
  }, {
    key: "info",
    value: function info() {
      var _this$infos;
      if (__classPrivateFieldGet(this, _LocalLogger_level, "f") >= Info) (_this$infos = this.infos).push.apply(_this$infos, arguments);
      return this;
    }
  }, {
    key: "debug",
    value: function debug() {
      var _this$debugs;
      if (__classPrivateFieldGet(this, _LocalLogger_level, "f") >= Debug) (_this$debugs = this.debugs).push.apply(_this$debugs, arguments);
      return this;
    }
  }, {
    key: "error",
    value: function error() {
      if (__classPrivateFieldGet(this, _LocalLogger_level, "f") >= ErrorLevel) throw Error.apply(void 0, arguments);
      return this;
    }
  }]);
}();
_LocalLogger_level = new WeakMap();
export function wrap(f) {
  return function () {
    current = new LocalLogger();
    f(current);
    reset();
  };
}
/**
 * Set the singleton logger to be a custom logger.
 */
export function set(newLogger) {
  current = newLogger;
  return current;
}
/**
 * Reset the main logger to use the default Vega Logger.
 */
export function reset() {
  current = main;
  return current;
}
export function error() {
  var _current;
  (_current = current).error.apply(_current, arguments);
}
export function warn() {
  var _current2;
  (_current2 = current).warn.apply(_current2, arguments);
}
export function info() {
  var _current3;
  (_current3 = current).info.apply(_current3, arguments);
}
export function debug() {
  var _current4;
  (_current4 = current).debug.apply(_current4, arguments);
}